<template>
  <main>
    <mdb-container class="mt-3 mb-3">
      <mdb-btn tag="a" gradient="green" floating size="lg" @click="back"><mdb-icon icon="arrow-left"/></mdb-btn>
      <mdb-container>
        <mdb-row class="mdb-lightbox">
          <mdb-col
            :key="'img-key' + img.index"
            md="4"
            v-for="img in images"
            @click.native="showLightbox2(img.index)"
          >
            <figure>
              <img :src="img.src" class="img-fluid" alt="">
            </figure>
          </mdb-col>
        </mdb-row>
      </mdb-container>
      <mdb-lightbox
        :visible="visible2"
        :imgs="img2"
        :index="index2"
        @hide="handleHide2">
      </mdb-lightbox>
    </mdb-container>
  </main>
</template>

<script>
  import { mdbContainer, mdbRow, mdbCol, mdbIcon, mdbBtn, mdbLightbox, mdbCarousel, mdbCarouselItem, mdbCarouselCaption, mdbCard, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbNavItem } from "mdbvue";

  export default {
    name: 'Show',
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbIcon,
      mdbBtn,
      mdbLightbox,
      mdbCarousel,
      mdbCarouselItem,
      mdbCarouselCaption,
      mdbCard,
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbNavItem
    },
    created() {
      this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT')
    },
    data() {
      return {
        album: null,
        images: [],
        visible2: false,
        index2: 0
      };
    },
    mounted() {
      this.album = this.$store.state.gallery.albums.find(
        album => album.id === this.$route.params.albumid
      );
    },
    computed: {
      img2() {
        if (this.album !== null) {
          const _images = [];

          for (let i = 1; i <= this.album.length; i++) {
            this.images.push({
              index: i - 1,
              src: `/images/albums/${this.$route.params.albumid}/${i}.jpg`
            });
            _images.push(`/images/albums/${this.$route.params.albumid}/${i}.jpg`,)
          }

          return _images;
        }

        return [];

      }
    },
    methods: {
      showLightbox2(index2) {
        this.index2 = index2;
        this.visible2 = true;
      },
      handleHide2() {
        this.visible2 = false;
      },
      back() {
        this.$router.back();
      }
    }
  };
</script>

<style scoped>
  @media (min-width: 768px) {
    .carousel-multi-item-2 .col-md-3 {
      float: left;
      width: 25%;
      max-width: 100%; } }

  .carousel-multi-item-2 .card img {
    border-radius: 2px; }

  figure {
    cursor: pointer;
  }
</style>
